<template>
  <div>
    <div v-if="loading" class="login-page">
      <p class="muted">Checking login status...</p>
    </div>

    <div v-else-if="user" class="authenticated-app">
      <Home />

      <button type="button" class="logout-floating-button" @click="handleLogout">
        Log out
      </button>
    </div>

    <main v-else class="login-page">
      <section class="login-card">
        <div class="stack">
          <div class="center">
            <h1>Private Login</h1>
            <p class="muted">Sign in with an approved Google account.</p>
          </div>

          <p v-if="error" class="error-message">
            {{ error }}
          </p>

          <button type="button" class="primary-button" @click="handleGoogleLogin">
            Continue with Google
          </button>

          <p class="small-text">
            Only emails added to the allowlist can access this website.
          </p>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
import firebase from "firebase/app";
import "firebase/auth";
import Home from "../view/Home.vue"

const firebaseConfig = {
  apiKey: "AIzaSyBxzJEK-27xi5HPzTy9YDpBGNdK8AHB2Xo",
  authDomain: "bilag-c8124.firebaseapp.com",
  projectId: "bilag-c8124",
  storageBucket: "bilag-c8124.firebasestorage.app",
  messagingSenderId: "793543853161",
  appId: "1:793543853161:web:7c8f170396489923c90ef8",
};

if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
}

const auth = firebase.auth();
const provider = new firebase.auth.GoogleAuthProvider();

const allowedEmails = [
   "hihi7239@gmail.com",
  "tjddlr22@gmail.com",
  "leb6505@gmail.com",
  "alexyzleew@gmail.com",
].map(function (email) {
  return email.toLowerCase();
});

export default {
  name: "LoginPage",
  components: {
    Home,
  },

  data: function () {
    return {
      user: null,
      loading: true,
      error: "",
      unsubscribeAuth: null,
    };
  },

  mounted: function () {
    var self = this;

    this.unsubscribeAuth = auth.onAuthStateChanged(async function (currentUser) {
      self.error = "";

      if (!currentUser) {
        self.user = null;
        self.loading = false;
        return;
      }

      var email = currentUser.email ? currentUser.email.toLowerCase() : "";

      if (!email || allowedEmails.indexOf(email) === -1) {
        await auth.signOut();
        self.user = null;
        self.error = "This Google account is not allowed to access this website.";
        self.loading = false;
        return;
      }

      self.user = currentUser;
      self.loading = false;
    });
  },

  beforeDestroy: function () {
    if (this.unsubscribeAuth) {
      this.unsubscribeAuth();
    }
  },

  methods: {
    handleGoogleLogin: async function () {
      this.error = "";

      try {
        var result = await auth.signInWithPopup(provider);
        var email = result.user.email ? result.user.email.toLowerCase() : "";

        if (!email || allowedEmails.indexOf(email) === -1) {
          await auth.signOut();
          this.error = "This Google account is not allowed to access this website.";
        }
      } catch (err) {
        this.error = err.message || "Login failed. Please try again.";
      }
    },

    handleLogout: async function () {
      await auth.signOut();
    },
  },
};
</script>

<style scoped>
.login-page {
  min-height: 100vh;
  background: #f1f5f9;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 16px;
  box-sizing: border-box;
}

.login-card {
  width: 100%;
  max-width: 420px;
  background: white;
  border-radius: 20px;
  padding: 32px;
  box-shadow: 0 20px 40px rgba(15, 23, 42, 0.12);
  box-sizing: border-box;
}

.authenticated-app {
  min-height: 100vh;
  width: 100%;
}

.logout-floating-button {
  position: fixed;
  right: 24px;
  bottom: 24px;
  z-index: 9999;
  border: none;
  border-radius: 999px;
  background: #0f172a;
  color: white;
  padding: 12px 18px;
  font-weight: 700;
  cursor: pointer;
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.2);
}

.logout-floating-button:hover {
  background: #334155;
}

.stack {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.center {
  text-align: center;
}

h1 {
  margin: 0;
  font-size: 30px;
  line-height: 1.2;
  color: #0f172a;
}

.muted {
  color: #64748b;
  margin: 8px 0 0;
}

.small-text {
  text-align: center;
  color: #64748b;
  font-size: 12px;
  margin: 0;
}

.primary-button,
.secondary-button {
  width: 100%;
  border-radius: 12px;
  padding: 14px 16px;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
}

.primary-button {
  border: none;
  background: #0f172a;
  color: white;
}

.primary-button:hover {
  background: #334155;
}

.secondary-button {
  border: 1px solid #cbd5e1;
  background: white;
  color: #0f172a;
}

.secondary-button:hover {
  background: #f8fafc;
}

.error-message {
  background: #fef2f2;
  color: #b91c1c;
  border-radius: 12px;
  padding: 12px 16px;
  font-size: 14px;
  margin: 0;
}

.private-box {
  border: 1px solid #e2e8f0;
  background: #f8fafc;
  border-radius: 12px;
  padding: 16px;
  color: #334155;
  font-size: 14px;
}

.check-icon {
  width: 56px;
  height: 56px;
  border-radius: 999px;
  background: #0f172a;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  font-size: 28px;
  font-weight: 700;
}
</style>
